var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('div',{staticClass:"absolute top-0 right-0 mt-20 mr-20"},[_c('div',{class:_vm.messageClasses},[_c('span',[_vm._v(_vm._s(_vm.message.text))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }